import React from 'react';

function About() {
  return (
    <div className="page">
      <h2>About</h2>
      <p>This deployment was created to test the vibe-deploy system end-to-end.</p>
    </div>
  );
}

export default About;
